<router-outlet></router-outlet>


  <ion-fab slot="fixed" vertical="bottom" horizontal="end">
    <a href="tel:+36301219583">
    <ion-fab-button color="danger">
      <ion-icon name="bandage"></ion-icon>
    </ion-fab-button>
    </a>
    <!--ion-fab-list side="top">
      <ion-fab-button>
        <ion-icon name="document"></ion-icon>
      </ion-fab-button>
      <ion-fab-button>
        <ion-icon name="color-palette"></ion-icon>
      </ion-fab-button>
      <ion-fab-button>
        <ion-icon name="globe"></ion-icon>
      </ion-fab-button>
    </ion-fab-list-->
  </ion-fab>